import React, { useEffect, useId, useState } from "react";
import { useConfigStore, useAccountStore, useSpacesStore } from "./store";
import { useLocation, useNavigate } from "react-router-dom";
import { useIdle } from "@uidotdev/usehooks";
import { interceptor } from './services/http';
import ReactGA from "react-ga4";

ReactGA.initialize("G-F5EZ6G31GK");

function App({ children }) {
  const { config, fetch: fetchConfig } = useConfigStore();
  const { spaces, fetch: fetchSpaces } = useSpacesStore();
  const { me, fetch: fetchUser, logout } = useAccountStore();
  const [finished, setFinished] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const idle = useIdle(60000);

  useEffect(() => {
    interceptor(navigate, logout);
  });

  useEffect(() => {
    if (idle && config && config.is_checkin_station && me) {
      logout();
    }
  }, [idle, config, me, logout]);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  useEffect(() => {
    const init = async () => {
      await fetchConfig();
      await fetchSpaces();
      await fetchUser();
      setFinished(true);
    };
    init();
  }, [fetchConfig, fetchSpaces, fetchUser]);

  return finished && <>{children}</>;
}

export default App;
